import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
import * as franc from 'franc';
import { ReactFlowInstance } from 'reactflow';

export const languageMapping: {
  [key: string]: { name: string; country: string };
} = {
  af: { name: 'Afrikaans', country: 'ZA' },
  sq: { name: 'Albanian', country: 'AL' },
  am: { name: 'Amharic', country: 'ET' },
  ar: { name: 'Arabic', country: 'SA' },
  hy: { name: 'Armenian', country: 'AM' },
  as: { name: 'Assamese', country: 'IN' },
  ay: { name: 'Aymara', country: 'BO' },
  az: { name: 'Azerbaijani', country: 'AZ' },
  bm: { name: 'Bambara', country: 'ML' },
  eu: { name: 'Basque', country: 'ES' },
  be: { name: 'Belarusian', country: 'BY' },
  bn: { name: 'Bengali', country: 'BD' },
  bho: { name: 'Bhojpuri', country: 'IN' },
  bs: { name: 'Bosnian', country: 'BA' },
  bg: { name: 'Bulgarian', country: 'BG' },
  ca: { name: 'Catalan', country: 'ES' },
  ceb: { name: 'Cebuano', country: 'PH' },
  zh: { name: 'Chinese (Simplified)', country: 'CN' },
  'zh-CN': { name: 'Chinese (Simplified)', country: 'CN' },
  'zh-TW': { name: 'Chinese (Traditional)', country: 'TW' },
  co: { name: 'Corsican', country: 'FR' },
  hr: { name: 'Croatian', country: 'HR' },
  cs: { name: 'Czech', country: 'CZ' },
  da: { name: 'Danish', country: 'DK' },
  dv: { name: 'Dhivehi', country: 'MV' },
  doi: { name: 'Dogri', country: 'IN' },
  nl: { name: 'Dutch', country: 'NL' },
  en: { name: 'English', country: 'US' },
  eo: { name: 'Esperanto', country: 'NONE' },
  et: { name: 'Estonian', country: 'EE' },
  ee: { name: 'Ewe', country: 'GH' },
  fil: { name: 'Filipino', country: 'PH' },
  fi: { name: 'Finnish', country: 'FI' },
  fr: { name: 'French', country: 'FR' },
  fy: { name: 'Frisian', country: 'NL' },
  gl: { name: 'Galician', country: 'ES' },
  ka: { name: 'Georgian', country: 'GE' },
  de: { name: 'German', country: 'DE' },
  el: { name: 'Greek', country: 'GR' },
  gn: { name: 'Guarani', country: 'PY' },
  gu: { name: 'Gujarati', country: 'IN' },
  ht: { name: 'Haitian Creole', country: 'HT' },
  ha: { name: 'Hausa', country: 'NG' },
  haw: { name: 'Hawaiian', country: 'US' },
  he: { name: 'Hebrew', country: 'IL' },
  hi: { name: 'Hindi', country: 'IN' },
  hmn: { name: 'Hmong', country: 'CN' },
  hu: { name: 'Hungarian', country: 'HU' },
  is: { name: 'Icelandic', country: 'IS' },
  ig: { name: 'Igbo', country: 'NG' },
  ilo: { name: 'Ilocano', country: 'PH' },
  id: { name: 'Indonesian', country: 'ID' },
  ga: { name: 'Irish', country: 'IE' },
  it: { name: 'Italian', country: 'IT' },
  ja: { name: 'Japanese', country: 'JP' },
  jv: { name: 'Javanese', country: 'ID' },
  kn: { name: 'Kannada', country: 'IN' },
  kk: { name: 'Kazakh', country: 'KZ' },
  km: { name: 'Khmer', country: 'KH' },
  rw: { name: 'Kinyarwanda', country: 'RW' },
  gom: { name: 'Konkani', country: 'IN' },
  ko: { name: 'Korean', country: 'KR' },
  kri: { name: 'Krio', country: 'SL' },
  ku: { name: 'Kurdish', country: 'IQ' },
  ckb: { name: 'Kurdish (Sorani)', country: 'IQ' },
  ky: { name: 'Kyrgyz', country: 'KG' },
  lo: { name: 'Lao', country: 'LA' },
  la: { name: 'Latin', country: 'VA' },
  lv: { name: 'Latvian', country: 'LV' },
  ln: { name: 'Lingala', country: 'CD' },
  lt: { name: 'Lithuanian', country: 'LT' },
  lg: { name: 'Luganda', country: 'UG' },
  lb: { name: 'Luxembourgish', country: 'LU' },
  mk: { name: 'Macedonian', country: 'MK' },
  mai: { name: 'Maithili', country: 'IN' },
  mg: { name: 'Malagasy', country: 'MG' },
  ms: { name: 'Malay', country: 'MY' },
  ml: { name: 'Malayalam', country: 'IN' },
  mt: { name: 'Maltese', country: 'MT' },
  mi: { name: 'Maori', country: 'NZ' },
  mr: { name: 'Marathi', country: 'IN' },
  'mni-Mtei': { name: 'Meiteilon (Manipuri)', country: 'IN' },
  lus: { name: 'Mizo', country: 'IN' },
  mn: { name: 'Mongolian', country: 'MN' },
  my: { name: 'Myanmar (Burmese)', country: 'MM' },
  ne: { name: 'Nepali', country: 'NP' },
  no: { name: 'Norwegian', country: 'NO' },
  ny: { name: 'Nyanja (Chichewa)', country: 'MW' },
  or: { name: 'Odia (Oriya)', country: 'IN' },
  om: { name: 'Oromo', country: 'ET' },
  ps: { name: 'Pashto', country: 'AF' },
  fa: { name: 'Persian', country: 'IR' },
  pl: { name: 'Polish', country: 'PL' },
  pt: { name: 'Portuguese', country: 'PT' },
  pa: { name: 'Punjabi', country: 'IN' },
  qu: { name: 'Quechua', country: 'PE' },
  ro: { name: 'Romanian', country: 'RO' },
  ru: { name: 'Russian', country: 'RU' },
  sm: { name: 'Samoan', country: 'WS' },
  sa: { name: 'Sanskrit', country: 'IN' },
  gd: { name: 'Scots Gaelic', country: 'GB' },
  nso: { name: 'Sepedi', country: 'ZA' },
  sr: { name: 'Serbian', country: 'RS' },
  st: { name: 'Sesotho', country: 'LS' },
  sn: { name: 'Shona', country: 'ZW' },
  sd: { name: 'Sindhi', country: 'PK' },
  si: { name: 'Sinhala', country: 'LK' },
  sk: { name: 'Slovak', country: 'SK' },
  sl: { name: 'Slovenian', country: 'SI' },
  so: { name: 'Somali', country: 'SO' },
  es: { name: 'Spanish', country: 'ES' },
  su: { name: 'Sundanese', country: 'ID' },
  sw: { name: 'Swahili', country: 'TZ' },
  sv: { name: 'Swedish', country: 'SE' },
  tl: { name: 'Tagalog (Filipino)', country: 'PH' },
  tg: { name: 'Tajik', country: 'TJ' },
  ta: { name: 'Tamil', country: 'IN' },
  tt: { name: 'Tatar', country: 'RU' },
  te: { name: 'Telugu', country: 'IN' },
  th: { name: 'Thai', country: 'TH' },
  ti: { name: 'Tigrinya', country: 'ER' },
  ts: { name: 'Tsonga', country: 'ZA' },
  tr: { name: 'Turkish', country: 'TR' },
  tk: { name: 'Turkmen', country: 'TM' },
  ak: { name: 'Twi', country: 'GH' },
  uk: { name: 'Ukrainian', country: 'UA' },
  ur: { name: 'Urdu', country: 'PK' },
  ug: { name: 'Uyghur', country: 'CN' },
  uz: { name: 'Uzbek', country: 'UZ' },
  vi: { name: 'Vietnamese', country: 'VN' },
  cy: { name: 'Welsh', country: 'GB' },
  xh: { name: 'Xhosa', country: 'ZA' },
  yi: { name: 'Yiddish', country: 'IL' },
  yo: { name: 'Yoruba', country: 'NG' },
  zu: { name: 'Zulu', country: 'ZA' },
};

const francToGoogleLanguageMap: { [key: string]: string } = {
  cmn: 'zh-CN', // Mandarin Chinese
  spa: 'es', // Spanish
  eng: 'en', // English
  rus: 'ru', // Russian
  arb: 'ar', // Standard Arabic
  ben: 'bn', // Bengali
  hin: 'hi', // Hindi
  por: 'pt', // Portuguese
  ind: 'id', // Indonesian
  jpn: 'ja', // Japanese
  fra: 'fr', // French
  deu: 'de', // German
  jav: 'jw', // Javanese
  kor: 'ko', // Korean
  tel: 'te', // Telugu
  vie: 'vi', // Vietnamese
  mar: 'mr', // Marathi
  ita: 'it', // Italian
  tam: 'ta', // Tamil
  tur: 'tr', // Turkish
  urd: 'ur', // Urdu
  guj: 'gu', // Gujarati
  pol: 'pl', // Polish
  ukr: 'uk', // Ukrainian
  kan: 'kn', // Kannada
  mai: 'mai', // Maithili (no direct Google Translate code, using franc code)
  mal: 'ml', // Malayalam
  pes: 'fa', // Iranian Persian
  mya: 'my', // Burmese
  swh: 'sw', // Swahili
  sun: 'su', // Sundanese
  ron: 'ro', // Romanian
  pan: 'pa', // Panjabi
  bho: 'bho', // Bhojpuri (no direct Google Translate code, using franc code)
  amh: 'am', // Amharic
  hau: 'ha', // Hausa
  fuv: 'ff', // Nigerian Fulfulde (using 'ff' for Fulah in Google Translate)
  bos: 'bs', // Bosnian
  hrv: 'hr', // Croatian
  nld: 'nl', // Dutch
  srp: 'sr', // Serbian
  tha: 'th', // Thai
  ckb: 'ku', // Central Kurdish (using 'ku' for Kurdish in Google Translate)
  yor: 'yo', // Yoruba
  uzn: 'uz', // Northern Uzbek
  zlm: 'ms', // Malay
  ibo: 'ig', // Igbo
  npi: 'ne', // Nepali
  ceb: 'ceb', // Cebuano
  skr: 'sd', // Saraiki (using 'sd' for Sindhi in Google Translate as closest match)
  tgl: 'tl', // Tagalog
  hun: 'hu', // Hungarian
  azj: 'az', // North Azerbaijani
  sin: 'si', // Sinhala
  koi: 'kv', // Komi-Permyak (using 'kv' for Komi in Google Translate)
  ell: 'el', // Modern Greek
  ces: 'cs', // Czech
  mag: 'mag', // Magahi (no direct Google Translate code, using franc code)
  run: 'rn', // Rundi
  bel: 'be', // Belarusian
  plt: 'mg', // Plateau Malagasy (using 'mg' for Malagasy in Google Translate)
  qug: 'qu', // Chimborazo Highland Quichua (using 'qu' for Quechua in Google Translate)
  mad: 'mad', // Madurese (no direct Google Translate code, using franc code)
  nya: 'ny', // Nyanja
  zyb: 'za', // Yongbei Zhuang (using 'za' for Zhuang in Google Translate)
  pbu: 'ps', // Northern Pashto (using 'ps' for Pashto in Google Translate)
  kin: 'rw', // Kinyarwanda
  zul: 'zu', // Zulu
  bul: 'bg', // Bulgarian
  swe: 'sv', // Swedish
  lin: 'ln', // Lingala
  som: 'so', // Somali
  hms: 'hmn', // Southern Qiandong Miao (using 'hmn' for Hmong in Google Translate)
  hnj: 'hmn', // Hmong Njua (using 'hmn' for Hmong in Google Translate)
  ilo: 'ilo', // Iloko
  kaz: 'kk', // Kazakh
  uig: 'ug', // Uighur
  hat: 'ht', // Haitian
  khm: 'km', // Khmer
  prs: 'fa', // Dari (using 'fa' for Persian in Google Translate)
  hil: 'hil', // Hiligaynon (no direct Google Translate code, using franc code)
  sna: 'sn', // Shona
  tat: 'tt', // Tatar
  xho: 'xh', // Xhosa
  hye: 'hy', // Armenian
  min: 'min', // Minangkabau (no direct Google Translate code, using franc code)
  afr: 'af', // Afrikaans
  lua: 'lua', // Luba-Lulua (no direct Google Translate code, using franc code)
  sat: 'sat', // Santali (no direct Google Translate code, using franc code)
  bod: 'bo', // Tibetan
  tir: 'ti', // Tigrinya
  fin: 'fi', // Finnish
  slk: 'sk', // Slovak
  tuk: 'tk', // Turkmen
  dan: 'da', // Danish
  nob: 'no', // Norwegian Bokmål (using 'no' for Norwegian in Google Translate)
  suk: 'suk', // Sukuma (no direct Google Translate code, using franc code)
  als: 'sq', // Tosk Albanian (using 'sq' for Albanian in Google Translate)
  sag: 'sg', // Sango
  nno: 'no', // Norwegian Nynorsk (using 'no' for Norwegian in Google Translate)
  heb: 'iw', // Hebrew (Google Translate uses 'iw' for Hebrew)
  mos: 'mos', // Mossi (no direct Google Translate code, using franc code)
  tgk: 'tg', // Tajik
  cat: 'ca', // Catalan
  sot: 'st', // Southern Sotho
  kat: 'ka', // Georgian
  bcl: 'bcl', // Central Bikol (no direct Google Translate code, using franc code)
  glg: 'gl', // Galician
  lao: 'lo', // Lao
  lit: 'lt', // Lithuanian
  umb: 'umb', // Umbundu (no direct Google Translate code, using franc code)
  tsn: 'tn', // Tswana
  vec: 'vec', // Venetian (no direct Google Translate code, using franc code)
  nso: 'nso', // Pedi (Northern Sotho)
  ban: 'ban', // Balinese (no direct Google Translate code, using franc code)
  bug: 'bug', // Buginese (no direct Google Translate code, using franc code)
  knc: 'knc', // Central Kanuri (no direct Google Translate code, using franc code)
  kng: 'kg', // Koongo
  ibb: 'ibb', // Ibibio (no direct Google Translate code, using franc code)
  lug: 'lg', // Ganda
  ace: 'ace', // Achinese (no direct Google Translate code, using franc code)
  bam: 'bm', // Bambara
  tzm: 'tzm', // Central Atlas Tamazight (no direct Google Translate code, using franc code)
  ydd: 'yi', // Eastern Yiddish (using 'yi' for Yiddish in Google Translate)
  kmb: 'kmb', // Kimbundu (no direct Google Translate code, using franc code)
  lun: 'lun', // Lunda (no direct Google Translate code, using franc code)
  shn: 'shn', // Shan (no direct Google Translate code, using franc code)
  war: 'war', // Waray (Philippines)
  dyu: 'dyu', // Dyula (no direct Google Translate code, using franc code)
  wol: 'wo', // Wolof
  kir: 'ky', // Kirghiz
  nds: 'nds', // Low German (no direct Google Translate code, using franc code)
  fuf: 'ff', // Pular (using 'ff' for Fulah in Google Translate)
  mkd: 'mk', // Macedonian
  vmw: 'vmw', // Makhuwa (no direct Google Translate code, using franc code)
  zgh: 'zgh', // Standard Moroccan Tamazight (no direct Google Translate code, using franc code)
  ewe: 'ee', // Ewe
  khk: 'mn', // Halh Mongolian (using 'mn' for Mongolian in Google Translate)
  slv: 'sl', // Slovenian
  ayr: 'ay', // Central Aymara (using 'ay' for Aymara in Google Translate)
  bem: 'bem', // Bemba (Zambia) (no direct Google Translate code, using franc code)
  emk: 'emk', // Eastern Maninkakan (no direct Google Translate code, using franc code)
  bci: 'bci', // Baoulé (no direct Google Translate code, using franc code)
  bum: 'bum', // Bulu (Cameroon) (no direct Google Translate code, using franc code)
  epo: 'eo', // Esperanto
  pam: 'pam', // Pampanga (no direct Google Translate code, using franc code)
  tiv: 'tiv', // Tiv (no direct Google Translate code, using franc code)
  tpi: 'tpi', // Tok Pisin (no direct Google Translate code, using franc code)
  ven: 've', // Venda
  ssw: 'ss', // Swati
  nyn: 'nyn', // Nyankole (no direct Google Translate code, using franc code)
  kbd: 'kbd', // Kabardian (no direct Google Translate code, using franc code)
  iii: 'ii', // Sichuan Yi
  yao: 'yao', // Yao (no direct Google Translate code, using franc code)
  lvs: 'lv', // Standard Latvian (using 'lv' for Latvian in Google Translate)
  quz: 'qu', // Cusco Quechua (using 'qu' for Quechua in Google Translate)
  src: 'sc', // Logudorese Sardinian (using 'sc' for Sardinian in Google Translate)
  rup: 'rup', // Macedo-Romanian (no direct Google Translate code, using franc code)
  sco: 'sco', // Scots (no direct Google Translate code, using franc code)
  tso: 'ts', // Tsonga
  men: 'men', // Mende (Sierra Leone) (no direct Google Translate code, using franc code)
  fon: 'fon', // Fon (no direct Google Translate code, using franc code)
  nhn: 'nah', // Central Nahuatl (using 'nah' for Nahuatl in Google Translate)
  dip: 'dip', // Northeastern Dinka (no direct Google Translate code, using franc code)
  kde: 'kde', // Makonde (no direct Google Translate code, using franc code)
  kbp: 'kbp', // Kabiyè (no direct Google Translate code, using franc code)
  tem: 'tem', // Timne (no direct Google Translate code, using franc code)
  toi: 'toi', // Tonga (Zambia) (no direct Google Translate code, using franc code)
  ekk: 'et', // Standard Estonian (using 'et' for Estonian in Google Translate)
  snk: 'snk', // Soninke (no direct Google Translate code, using franc code)
  cjk: 'cjk', // Chokwe (no direct Google Translate code, using franc code)
  ada: 'ada', // Adangme (no direct Google Translate code, using franc code)
  aii: 'aii', // Assyrian Neo-Aramaic (no direct Google Translate code, using franc code)
  quy: 'qu', // Ayacucho Quechua (using 'qu' for Quechua in Google Translate)
  rmn: 'rom', // Balkan Romani (using 'rom' for Romani in Google Translate)
  bin: 'bin', // Bini (no direct Google Translate code, using franc code)
  gaa: 'gaa', // Ga (no direct Google Translate code, using franc code)
  ndo: 'ng', // Ndonga
};

// Define interface for country data
interface CountryData {
  code: string; // 2-letter code
  name: string; // Full country name
}

// Modified ISO_COUNTRIES mapping
export const ISO_COUNTRIES: Record<string, CountryData> = {
  AFG: { code: 'AF', name: 'Afghanistan' },
  ALA: { code: 'AX', name: 'Åland Islands' },
  ALB: { code: 'AL', name: 'Albania' },
  DZA: { code: 'DZ', name: 'Algeria' },
  ASM: { code: 'AS', name: 'American Samoa' },
  AND: { code: 'AD', name: 'Andorra' },
  AGO: { code: 'AO', name: 'Angola' },
  AIA: { code: 'AI', name: 'Anguilla' },
  ATA: { code: 'AQ', name: 'Antarctica' },
  ATG: { code: 'AG', name: 'Antigua and Barbuda' },
  ARG: { code: 'AR', name: 'Argentina' },
  ARM: { code: 'AM', name: 'Armenia' },
  ABW: { code: 'AW', name: 'Aruba' },
  AUS: { code: 'AU', name: 'Australia' },
  AUT: { code: 'AT', name: 'Austria' },
  AZE: { code: 'AZ', name: 'Azerbaijan' },
  BHS: { code: 'BS', name: 'Bahamas' },
  BHR: { code: 'BH', name: 'Bahrain' },
  BGD: { code: 'BD', name: 'Bangladesh' },
  BRB: { code: 'BB', name: 'Barbados' },
  BLR: { code: 'BY', name: 'Belarus' },
  BEL: { code: 'BE', name: 'Belgium' },
  BLZ: { code: 'BZ', name: 'Belize' },
  BEN: { code: 'BJ', name: 'Benin' },
  BMU: { code: 'BM', name: 'Bermuda' },
  BTN: { code: 'BT', name: 'Bhutan' },
  BOL: { code: 'BO', name: 'Bolivia' },
  BIH: { code: 'BA', name: 'Bosnia and Herzegovina' },
  BWA: { code: 'BW', name: 'Botswana' },
  BVT: { code: 'BV', name: 'Bouvet Island' },
  BRA: { code: 'BR', name: 'Brazil' },
  VGB: { code: 'VG', name: 'British Virgin Islands' },
  IOT: { code: 'IO', name: 'British Indian Ocean Territory' },
  BRN: { code: 'BN', name: 'Brunei' },
  BGR: { code: 'BG', name: 'Bulgaria' },
  BFA: { code: 'BF', name: 'Burkina Faso' },
  BDI: { code: 'BI', name: 'Burundi' },
  KHM: { code: 'KH', name: 'Cambodia' },
  CMR: { code: 'CM', name: 'Cameroon' },
  CAN: { code: 'CA', name: 'Canada' },
  CPV: { code: 'CV', name: 'Cape Verde' },
  CYM: { code: 'KY', name: 'Cayman Islands' },
  CAF: { code: 'CF', name: 'Central African Republic' },
  TCD: { code: 'TD', name: 'Chad' },
  CHL: { code: 'CL', name: 'Chile' },
  CHN: { code: 'CN', name: 'China' },
  HKG: { code: 'HK', name: 'Hong Kong' },
  MAC: { code: 'MO', name: 'Macao' },
  CXR: { code: 'CX', name: 'Christmas Island' },
  CCK: { code: 'CC', name: 'Cocos (Keeling) Islands' },
  COL: { code: 'CO', name: 'Colombia' },
  COM: { code: 'KM', name: 'Comoros' },
  COG: { code: 'CG', name: 'Republic of the Congo' },
  COD: { code: 'CD', name: 'Democratic Republic of the Congo' },
  COK: { code: 'CK', name: 'Cook Islands' },
  CRI: { code: 'CR', name: 'Costa Rica' },
  CIV: { code: 'CI', name: "Côte d'Ivoire" },
  HRV: { code: 'HR', name: 'Croatia' },
  CUB: { code: 'CU', name: 'Cuba' },
  CYP: { code: 'CY', name: 'Cyprus' },
  CZE: { code: 'CZ', name: 'Czech Republic' },
  DNK: { code: 'DK', name: 'Denmark' },
  DJI: { code: 'DJ', name: 'Djibouti' },
  DMA: { code: 'DM', name: 'Dominica' },
  DOM: { code: 'DO', name: 'Dominican Republic' },
  ECU: { code: 'EC', name: 'Ecuador' },
  EGY: { code: 'EG', name: 'Egypt' },
  SLV: { code: 'SV', name: 'El Salvador' },
  GNQ: { code: 'GQ', name: 'Equatorial Guinea' },
  ERI: { code: 'ER', name: 'Eritrea' },
  EST: { code: 'EE', name: 'Estonia' },
  ETH: { code: 'ET', name: 'Ethiopia' },
  FLK: { code: 'FK', name: 'Falkland Islands' },
  FRO: { code: 'FO', name: 'Faroe Islands' },
  FJI: { code: 'FJ', name: 'Fiji' },
  FIN: { code: 'FI', name: 'Finland' },
  FRA: { code: 'FR', name: 'France' },
  GUF: { code: 'GF', name: 'French Guiana' },
  PYF: { code: 'PF', name: 'French Polynesia' },
  ATF: { code: 'TF', name: 'French Southern Territories' },
  GAB: { code: 'GA', name: 'Gabon' },
  GMB: { code: 'GM', name: 'Gambia' },
  GEO: { code: 'GE', name: 'Georgia' },
  DEU: { code: 'DE', name: 'Germany' },
  GHA: { code: 'GH', name: 'Ghana' },
  GIB: { code: 'GI', name: 'Gibraltar' },
  GRC: { code: 'GR', name: 'Greece' },
  GRL: { code: 'GL', name: 'Greenland' },
  GRD: { code: 'GD', name: 'Grenada' },
  GLP: { code: 'GP', name: 'Guadeloupe' },
  GUM: { code: 'GU', name: 'Guam' },
  GTM: { code: 'GT', name: 'Guatemala' },
  GGY: { code: 'GG', name: 'Guernsey' },
  GIN: { code: 'GN', name: 'Guinea' },
  GNB: { code: 'GW', name: 'Guinea-Bissau' },
  GUY: { code: 'GY', name: 'Guyana' },
  HTI: { code: 'HT', name: 'Haiti' },
  HMD: { code: 'HM', name: 'Heard Island and McDonald Islands' },
  VAT: { code: 'VA', name: 'Vatican City' },
  HND: { code: 'HN', name: 'Honduras' },
  HUN: { code: 'HU', name: 'Hungary' },
  ISL: { code: 'IS', name: 'Iceland' },
  IND: { code: 'IN', name: 'India' },
  IDN: { code: 'ID', name: 'Indonesia' },
  IRN: { code: 'IR', name: 'Iran' },
  IRQ: { code: 'IQ', name: 'Iraq' },
  IRL: { code: 'IE', name: 'Ireland' },
  IMN: { code: 'IM', name: 'Isle of Man' },
  ISR: { code: 'IL', name: 'Israel' },
  ITA: { code: 'IT', name: 'Italy' },
  JAM: { code: 'JM', name: 'Jamaica' },
  JPN: { code: 'JP', name: 'Japan' },
  JEY: { code: 'JE', name: 'Jersey' },
  JOR: { code: 'JO', name: 'Jordan' },
  KAZ: { code: 'KZ', name: 'Kazakhstan' },
  KEN: { code: 'KE', name: 'Kenya' },
  KIR: { code: 'KI', name: 'Kiribati' },
  PRK: { code: 'KP', name: 'North Korea' },
  KOR: { code: 'KR', name: 'South Korea' },
  KWT: { code: 'KW', name: 'Kuwait' },
  KGZ: { code: 'KG', name: 'Kyrgyzstan' },
  LAO: { code: 'LA', name: 'Laos' },
  LVA: { code: 'LV', name: 'Latvia' },
  LBN: { code: 'LB', name: 'Lebanon' },
  LSO: { code: 'LS', name: 'Lesotho' },
  LBR: { code: 'LR', name: 'Liberia' },
  LBY: { code: 'LY', name: 'Libya' },
  LIE: { code: 'LI', name: 'Liechtenstein' },
  LTU: { code: 'LT', name: 'Lithuania' },
  LUX: { code: 'LU', name: 'Luxembourg' },
  MKD: { code: 'MK', name: 'North Macedonia' },
  MDG: { code: 'MG', name: 'Madagascar' },
  MWI: { code: 'MW', name: 'Malawi' },
  MYS: { code: 'MY', name: 'Malaysia' },
  MDV: { code: 'MV', name: 'Maldives' },
  MLI: { code: 'ML', name: 'Mali' },
  MLT: { code: 'MT', name: 'Malta' },
  MHL: { code: 'MH', name: 'Marshall Islands' },
  MTQ: { code: 'MQ', name: 'Martinique' },
  MRT: { code: 'MR', name: 'Mauritania' },
  MUS: { code: 'MU', name: 'Mauritius' },
  MYT: { code: 'YT', name: 'Mayotte' },
  MEX: { code: 'MX', name: 'Mexico' },
  FSM: { code: 'FM', name: 'Micronesia' },
  MDA: { code: 'MD', name: 'Moldova' },
  MCO: { code: 'MC', name: 'Monaco' },
  MNG: { code: 'MN', name: 'Mongolia' },
  MNE: { code: 'ME', name: 'Montenegro' },
  MSR: { code: 'MS', name: 'Montserrat' },
  MAR: { code: 'MA', name: 'Morocco' },
  MOZ: { code: 'MZ', name: 'Mozambique' },
  MMR: { code: 'MM', name: 'Myanmar' },
  NAM: { code: 'NA', name: 'Namibia' },
  NRU: { code: 'NR', name: 'Nauru' },
  NPL: { code: 'NP', name: 'Nepal' },
  NLD: { code: 'NL', name: 'Netherlands' },
  ANT: { code: 'AN', name: 'Netherlands Antilles' },
  NCL: { code: 'NC', name: 'New Caledonia' },
  NZL: { code: 'NZ', name: 'New Zealand' },
  NIC: { code: 'NI', name: 'Nicaragua' },
  NER: { code: 'NE', name: 'Niger' },
  NGA: { code: 'NG', name: 'Nigeria' },
  NIU: { code: 'NU', name: 'Niue' },
  NFK: { code: 'NF', name: 'Norfolk Island' },
  MNP: { code: 'MP', name: 'Northern Mariana Islands' },
  NOR: { code: 'NO', name: 'Norway' },
  OMN: { code: 'OM', name: 'Oman' },
  PAK: { code: 'PK', name: 'Pakistan' },
  PLW: { code: 'PW', name: 'Palau' },
  PSE: { code: 'PS', name: 'Palestine' },
  PAN: { code: 'PA', name: 'Panama' },
  PNG: { code: 'PG', name: 'Papua New Guinea' },
  PRY: { code: 'PY', name: 'Paraguay' },
  PER: { code: 'PE', name: 'Peru' },
  PHL: { code: 'PH', name: 'Philippines' },
  PCN: { code: 'PN', name: 'Pitcairn' },
  POL: { code: 'PL', name: 'Poland' },
  PRT: { code: 'PT', name: 'Portugal' },
  PRI: { code: 'PR', name: 'Puerto Rico' },
  QAT: { code: 'QA', name: 'Qatar' },
  REU: { code: 'RE', name: 'Réunion' },
  ROU: { code: 'RO', name: 'Romania' },
  RUS: { code: 'RU', name: 'Russia' },
  RWA: { code: 'RW', name: 'Rwanda' },
  BLM: { code: 'BL', name: 'Saint Barthélemy' },
  SHN: { code: 'SH', name: 'Saint Helena' },
  KNA: { code: 'KN', name: 'Saint Kitts and Nevis' },
  LCA: { code: 'LC', name: 'Saint Lucia' },
  MAF: { code: 'MF', name: 'Saint Martin' },
  SPM: { code: 'PM', name: 'Saint Pierre and Miquelon' },
  VCT: { code: 'VC', name: 'Saint Vincent and the Grenadines' },
  WSM: { code: 'WS', name: 'Samoa' },
  SMR: { code: 'SM', name: 'San Marino' },
  STP: { code: 'ST', name: 'São Tomé and Príncipe' },
  SAU: { code: 'SA', name: 'Saudi Arabia' },
  SEN: { code: 'SN', name: 'Senegal' },
  SRB: { code: 'RS', name: 'Serbia' },
  SYC: { code: 'SC', name: 'Seychelles' },
  SLE: { code: 'SL', name: 'Sierra Leone' },
  SGP: { code: 'SG', name: 'Singapore' },
  SVK: { code: 'SK', name: 'Slovakia' },
  SVN: { code: 'SI', name: 'Slovenia' },
  SLB: { code: 'SB', name: 'Solomon Islands' },
  SOM: { code: 'SO', name: 'Somalia' },
  ZAF: { code: 'ZA', name: 'South Africa' },
  SGS: { code: 'GS', name: 'South Georgia and the South Sandwich Islands' },
  SSD: { code: 'SS', name: 'South Sudan' },
  ESP: { code: 'ES', name: 'Spain' },
  LKA: { code: 'LK', name: 'Sri Lanka' },
  SDN: { code: 'SD', name: 'Sudan' },
  SUR: { code: 'SR', name: 'Suriname' },
  SJM: { code: 'SJ', name: 'Svalbard and Jan Mayen' },
  SWZ: { code: 'SZ', name: 'Eswatini' },
  SWE: { code: 'SE', name: 'Sweden' },
  CHE: { code: 'CH', name: 'Switzerland' },
  SYR: { code: 'SY', name: 'Syria' },
  TWN: { code: 'TW', name: 'Taiwan' },
  TJK: { code: 'TJ', name: 'Tajikistan' },
  TZA: { code: 'TZ', name: 'Tanzania' },
  THA: { code: 'TH', name: 'Thailand' },
  TLS: { code: 'TL', name: 'Timor-Leste' },
  TGO: { code: 'TG', name: 'Togo' },
  TKL: { code: 'TK', name: 'Tokelau' },
  TON: { code: 'TO', name: 'Tonga' },
  TTO: { code: 'TT', name: 'Trinidad and Tobago' },
  TUN: { code: 'TN', name: 'Tunisia' },
  TUR: { code: 'TR', name: 'Turkey' },
  TKM: { code: 'TM', name: 'Turkmenistan' },
  TCA: { code: 'TC', name: 'Turks and Caicos Islands' },
  TUV: { code: 'TV', name: 'Tuvalu' },
  UGA: { code: 'UG', name: 'Uganda' },
  UKR: { code: 'UA', name: 'Ukraine' },
  ARE: { code: 'AE', name: 'United Arab Emirates' },
  GBR: { code: 'GB', name: 'United Kingdom' },
  USA: { code: 'US', name: 'United States' },
  UMI: { code: 'UM', name: 'United States Minor Outlying Islands' },
  URY: { code: 'UY', name: 'Uruguay' },
  UZB: { code: 'UZ', name: 'Uzbekistan' },
  VUT: { code: 'VU', name: 'Vanuatu' },
  VEN: { code: 'VE', name: 'Venezuela' },
  VNM: { code: 'VN', name: 'Vietnam' },
  VIR: { code: 'VI', name: 'U.S. Virgin Islands' },
  WLF: { code: 'WF', name: 'Wallis and Futuna' },
  ESH: { code: 'EH', name: 'Western Sahara' },
  YEM: { code: 'YE', name: 'Yemen' },
  ZMB: { code: 'ZM', name: 'Zambia' },
  ZWE: { code: 'ZW', name: 'Zimbabwe' },
  XKX: { code: 'XK', name: 'Kosovo' },
};

export function detectLanguage(text: string): string {
  const francCode = franc.franc(text, {
    minLength: 10,
    only: Object.keys(francToGoogleLanguageMap),
  });
  const googleCode = francToGoogleLanguageMap[francCode];
  return googleCode || 'en'; // Default to English if no mapping found
}

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const cleanupPointerEvents = () => {
  // Immediate cleanup attempt
  document.body.style.removeProperty('pointer-events');

  // Backup cleanup after a short delay
  setTimeout(() => {
    document.body.style.removeProperty('pointer-events');
  }, 300);
};

export const nonProtectedRoutes = ['/', '/templates', '/pricing'];

export const getFileTypeFromUrl = (url: string | null | undefined) => {
  // Return 'unknown' if the URL is null or undefined
  if (!url) {
    return 'unknown';
  }
  
  try {
    // Get the URL without query parameters
    const urlWithoutParams = url.split('?')[0];
    // Extract file extension (convert to lowercase for consistency)
    const fileExtension = urlWithoutParams.split('.').pop()?.toLowerCase() || '';
    
    // Define arrays of known extensions
    const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg', 'bmp', 'tiff', 'tif', 'ico'];
    const videoExtensions = ['mp4', 'mov', 'avi', 'mkv', 'webm', 'flv', 'wmv', 'm4v', 'mpg', 'mpeg'];
    
    // Check if the extension is in our known lists
    if (imageExtensions.includes(fileExtension)) {
      return 'image';
    }
    
    if (videoExtensions.includes(fileExtension)) {
      return 'video';
    }
    
    // If extension check doesn't work, try checking full URL endings
    for (const ext of imageExtensions) {
      if (url.toLowerCase().endsWith(`.${ext}`)) {
        return 'image';
      }
    }
    
    for (const ext of videoExtensions) {
      if (url.toLowerCase().endsWith(`.${ext}`)) {
        return 'video';
      }
    }
    
    // Check for common patterns in URLs
    if (url.includes('/images/') || url.includes('/img/') || url.includes('image')) {
      return 'image';
    }
    
    if (url.includes('/videos/') || url.includes('/video/')) {
      return 'video';
    }
    
    // If we can't determine the type, return 'unknown'
    return 'unknown';
  } catch (error) {
    console.error('Error determining file type from URL:', error);
    return 'unknown';
  }
}




export const handleSaveTemplate = async ({
  reactFlowInstance,
  data,
  currentProject,
  dispatch,
  saveLogicTemplate,
  params, 
}: {
  reactFlowInstance: ReactFlowInstance,
  data: any,
  currentProject: any,
  dispatch: any,
  saveLogicTemplate: any,
  params: any,
}) => {
  const flowNodes = reactFlowInstance.getNodes();
      const flowEdges = reactFlowInstance.getEdges();
      const viewport = reactFlowInstance.getViewport();
      console.log('flowNodes', flowNodes);
      console.log('flowEdges', flowEdges);
      console.log('viewport', viewport);
      const flowData = {
        nodes: flowNodes,
        edges: flowEdges,
        viewport: viewport,
        timestamp: new Date().toISOString()
      };
      const logicTemplate = {
        name: `Logic Template - ${new Date().toLocaleString()}`,
        description: `Complete flow state with condition node ${data.id}`,
        logic_data: JSON.stringify(flowData),
        is_global: false,
        organization_id:currentProject?.organization_id,
        project_id: currentProject?.id,
      };
      console.log('logicTemplate', logicTemplate);
      console.log('handle save template logged here');
      await dispatch(saveLogicTemplate({
        projectIdOrSlug: params.id,
        data: logicTemplate
      })); 
    
 }